import {
  createCSSPartsObjFromList,
  createCSSPartsProxy
} from '../utils/cssParts/cssParts';

export const CSS_PARTS_LIST: string[] = [
  'footer',
  'footer__notice',
  'footer__icons'
];

export const CSS_PARTS: Record<string, string> = createCSSPartsProxy(
  createCSSPartsObjFromList(CSS_PARTS_LIST)
);
